import React from "react";
import Chart from "react-apexcharts";

const PlayerGameBar = (props) => {
  // Game Bar chart logic start here
  const dataRunsValues = Object.values(props.runsRangeData).map((value) =>
    parseInt(value, 10)
  );

  const dataOnesValues = Object.values(props.onesRangeData).map((value) =>
    parseFloat(value, 10)
  );
  const dataTwosValues = Object.values(props.twosRangeData).map((value) =>
    parseFloat(value, 10)
  );
  const dataThreesValues = Object.values(props.threesRangeData).map((value) =>
    parseFloat(value, 10)
  );
  const dataFivesValues = Object.values(props.fivesRangeData).map((value) =>
    parseFloat(value, 10)
  );
  const dataSevensValues = Object.values(props.sevensRangeData).map((value) =>
    parseFloat(value, 10)
  );
  const dataEightsValues = Object.values(props.eightsRangeData).map((value) =>
    parseFloat(value, 10)
  );
  const dataNinesValues = Object.values(props.ninesRangeData).map((value) =>
    parseFloat(value, 10)
  );
  const dataOutsValues = Object.values(props.outsRangeData).map((value) =>
    parseFloat(value, 10)
  );

  const dataWksValues = Object.values(props.wksRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataFoursValues = Object.values(props.foursRangeData).map((value) =>
    parseInt(value, 10)
  ); // Convert strings to integers
  const dataSixesValues = Object.values(props.sixesRangeData).map((value) =>
    parseInt(value, 10)
  ); // Convert strings to integers
  const dataMdnsValues = Object.values(props.mdnsRangeData).map((value) =>
    parseInt(value, 10)
  ); // Convert strings to integers
  const dataFpValues = Object.values(props.fpsRangeData).map((value) =>
    parseInt(value, 10)
  );

  const dataCsValues = Object.values(props.csRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataCwksValues = Object.values(props.cwksRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataStsValues = Object.values(props.stsRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataRodsValues = Object.values(props.rodsRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataRoasValues = Object.values(props.roasRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataDksValues = Object.values(props.dksRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataNoValues = Object.values(props.noRangeData).map((value) =>
    parseInt(value, 10)
  );
  const dataHattrickValues = Object.values(props.hattrickRangeData).map(
    (value) => parseInt(value, 10)
  );

  const formatteRunsdData = {
    series: [
      {
        name: "Runs Per Inning",
        data: dataRunsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1-9",
          "10-19",
          "20-29",
          "30-39",
          "40-49",
          "50-59",
          "60-69",
          "70-79",
          "70-79",
          "80-89",
          "90-99",
          "100-199",
          "200+",
        ],
      },
      title: {
        text: "Runs Per Inning",
        align: "left",
      },
    },
  };
  const formattedOnesData = {
    series: [
      {
        name: "Ones Per Inning",
        data: dataOnesValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Ones Per Inning",
        align: "left",
      },
    },
  };
  const formattedTwosData = {
    series: [
      {
        name: "Twos Per Inning",
        data: dataTwosValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Twos Per Inning",
        align: "left",
      },
    },
  };
  const formattedThreesData = {
    series: [
      {
        name: "Threes Per Inning",
        data: dataThreesValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Threes Per Inning",
        align: "left",
      },
    },
  };
  const formattedFivesData = {
    series: [
      {
        name: "Fives Per Inning",
        data: dataFivesValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Fives Per Inning",
        align: "left",
      },
    },
  };
  const formattedSevensData = {
    series: [
      {
        name: "Sevens Per Inning",
        data: dataSevensValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Sevens Per Inning",
        align: "left",
      },
    },
  };
  const formattedEightsData = {
    series: [
      {
        name: "Eights Per Inning",
        data: dataEightsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Eights Per Inning",
        align: "left",
      },
    },
  };
  const formattedNinesData = {
    series: [
      {
        name: "Nines Per Inning",
        data: dataNinesValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Nines Per Inning",
        align: "left",
      },
    },
  };
  const formattedOutsData = {
    series: [
      {
        name: "Outs Per Inning",
        data: dataOutsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Outs Per Inning",
        align: "left",
      },
    },
  };

  const formattedWksData = {
    series: [
      {
        name: "Wickets Per Inning",
        data: dataWksValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Wickets Per Inning",
        align: "left",
      },
    },
  };

  const formattedFourData = {
    series: [
      {
        name: "Fours Per Inning",
        data: dataFoursValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Fours Per Inning",
        align: "left",
      },
    },
  };
  const formattedSixesData = {
    series: [
      {
        name: "Sixes Per Inning",
        data: dataSixesValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8-9", "10+"],
      },
      title: {
        text: "Sixes Per Inning",
        align: "left",
      },
    },
  };
  const formattedMdnsData = {
    series: [
      {
        name: "Maidens Per Inning",
        data: dataMdnsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9-10",
          "11-15",
          "16-20",
          "21+",
        ],
      },
      title: {
        text: "Maidens Per Inning",
        align: "left",
      },
    },
  };
  const formattedFpData = {
    series: [
      {
        name: "Fantasy Points Per Inning",
        data: dataFpValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: [
          "1-50",
          "51-100",
          "101-150",
          "151-200",
          "201-300",
          "301-400",
          "401-500",
          "501+",
        ],
      },
      title: {
        text: "Fantasy Points Per Inning",
        align: "left",
      },
    },
  };
  const formattedCsData = {
    series: [
      {
        name: "Catches Per Inning",
        data: dataCsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Catches Per Inning",
        align: "left",
      },
    },
  };
  const formattedCwksData = {
    series: [
      {
        name: "Catches (Wicket-Keeper) Per Inning",
        data: dataCwksValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Catches (Wicket-Keeper) Per Inning",
        align: "left",
      },
    },
  };
  const formattedStsData = {
    series: [
      {
        name: "Stumpings Per Inning",
        data: dataStsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Stumpings Per Inning",
        align: "left",
      },
    },
  };
  const formattedRodsData = {
    series: [
      {
        name: "Run-Out Direct Per Inning",
        data: dataRodsValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Run-Out Direct Per Inning",
        align: "left",
      },
    },
  };
  const formattedRoasData = {
    series: [
      {
        name: "Run-Out Assisted Per Inning",
        data: dataRoasValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Run-Out Assisted Per Inning",
        align: "left",
      },
    },
  };
  const formattedDksData = {
    series: [
      {
        name: "Duck Per Inning",
        data: dataDksValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Duck Per Inning",
        align: "left",
      },
    },
  };
  const formattedNoData = {
    series: [
      {
        name: "Not Out Per Inning",
        data: dataNoValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Not Out Per Inning",
        align: "left",
      },
    },
  };
  const formattedHattrickData = {
    series: [
      {
        name: "Hat-Trick Per Inning",
        data: dataHattrickValues,
      },
    ],
    chartOptions: {
      xaxis: {
        categories: ["1", "2", "3", "4", "5", "6", "7", "8+"],
      },
      title: {
        text: "Hat-Trick Per Inning",
        align: "left",
      },
    },
  };
  // Game Bar chart logic start here
  return (
    <>
      <ul className="sponsor_list bonus-card">
        <li>
          <div className="sponsorslide">
            <Chart
              options={formatteRunsdData.chartOptions}
              series={formatteRunsdData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        {props.clubDetails?.game_type === 3 && (
          <>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedOnesData.chartOptions}
                  series={formattedOnesData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedTwosData.chartOptions}
                  series={formattedTwosData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedThreesData.chartOptions}
                  series={formattedThreesData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>

            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedFourData.chartOptions}
                  series={formattedFourData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedFivesData.chartOptions}
                  series={formattedFivesData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedSixesData.chartOptions}
                  series={formattedSixesData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedSevensData.chartOptions}
                  series={formattedSevensData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedEightsData.chartOptions}
                  series={formattedEightsData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedNinesData.chartOptions}
                  series={formattedNinesData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedOutsData.chartOptions}
                  series={formattedOutsData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
          </>
        )}
        {props.clubDetails?.game_type !== 3 && (
          <>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedFourData.chartOptions}
                  series={formattedFourData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
            <li>
              <div className="sponsorslide">
                <Chart
                  options={formattedSixesData.chartOptions}
                  series={formattedSixesData.series}
                  type="bar"
                  height={350}
                />
              </div>
            </li>
          </>
        )}
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedWksData.chartOptions}
              series={formattedWksData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedMdnsData.chartOptions}
              series={formattedMdnsData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedFpData.chartOptions}
              series={formattedFpData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>

        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedCsData.chartOptions}
              series={formattedCsData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedCwksData.chartOptions}
              series={formattedCwksData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedStsData.chartOptions}
              series={formattedStsData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedRodsData.chartOptions}
              series={formattedRodsData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedRoasData.chartOptions}
              series={formattedRoasData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedDksData.chartOptions}
              series={formattedDksData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedNoData.chartOptions}
              series={formattedNoData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
        <li>
          <div className="sponsorslide">
            <Chart
              options={formattedHattrickData.chartOptions}
              series={formattedHattrickData.series}
              type="bar"
              height={350}
            />
          </div>
        </li>
      </ul>
    </>
  );
};

export default PlayerGameBar;
